import { useStore } from '@thd-nucleus/experience-context';
import {
  useDataModel, alias, string, shape, bool,
} from '@thd-nucleus/data-sources';

const clientOnlyProduct = alias('product').params({ itemId: string().isRequired() }).shape({
  itemId: string(),
  dataSource: string(),
  info: shape({
    recommendationFlags: shape({
      collections: bool()
    }),
  }),
});

export const useRecommendationFlags = (anchorId) => {
  const { storeId } = useStore();

  let { data, loading, error } = useDataModel('clientOnlyProduct', {
    variables: {
      itemId: anchorId,
      storeId,
    },
    skip: !anchorId,
    ssr: false,
    dataModel: { clientOnlyProduct }
  });
  return { data, loading, error };
};